import React from 'react'
import Navigation from '../components/header/Navigation';
import LearnableBody from '../components/body/LearnableBody';

const Learnable = () => {
    return (
        <React.Fragment>
            <Navigation />
            <LearnableBody />
        </React.Fragment>
    )
};

export default Learnable;